/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SendContainerAliases {
  AVATAR_SEND_CONTAINER = 'avatar-send-container',
  BARCODE_EXAM_CONTAINER = 'barcode-exam-container',
  BUTTON_SEND_CONTAINER = 'button-send-container',
  PANEL_RESOLUTION = 'panel-resolution',
  SEND_CONTAINE_PANEL = 'send-containe-panel',
  SEND_CONTAINER_BUTTON_PANEL = 'send-container-button-panel',
  SEND_CONTAINER_LAYOUT = 'send-container-layout',
  SEND_EXAM_SAMPLE_PANEL = 'send-exam-sample-panel',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
}
export { SendContainerAliases };
